import React from 'react';
import { NavLink } from 'react-router-dom';
import { Search, Bell } from 'lucide-react';
export function TopNav() {
  const navLinks = [{
    name: 'Dashboard',
    path: '/dashboard/overview'
  }, {
    name: 'Workforce',
    path: '/workforce'
  }, {
    name: 'Compliance',
    path: '/compliance'
  }, {
    name: 'Reports',
    path: '/reports'
  }, {
    name: 'Network',
    path: '/network'
  }];
  return <header className="h-16 border-b border-white/5 bg-[var(--bg)] flex items-center justify-between px-6 shrink-0" data-id="element-56">
      <div className="flex items-center gap-8" data-id="element-57">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-58">
          <div className="w-6 h-6 bg-[var(--accent)] rounded flex items-center justify-center" data-id="element-59">
            <div className="w-2.5 h-2.5 bg-black rounded-sm" data-id="element-60" />
          </div>
          <span className="font-display font-bold text-lg tracking-wide text-white" data-id="element-61">
            BIBDE
          </span>
        </div>

        {/* Primary Nav */}
        <nav className="hidden md:flex items-center gap-6" data-id="element-62">
          {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
          isActive
        }) => `text-sm font-medium transition-colors ${isActive ? 'text-white' : 'text-[var(--muted)] hover:text-white/80'}`} data-id="element-63">
              {link.name}
            </NavLink>)}
        </nav>
      </div>

      <div className="flex items-center gap-6" data-id="element-64">
        {/* Search */}
        <div className="relative hidden sm:block" data-id="element-65">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" data-id="element-66" />
          <input type="text" placeholder="Search..." className="bg-[var(--surface)] border border-white/5 rounded-md pl-9 pr-4 py-1.5 text-sm text-white focus:outline-none focus:border-[var(--accent)]/50 transition-colors w-64 placeholder:text-[var(--muted)]" data-id="element-67" />
        </div>

        {/* Actions */}
        <div className="flex items-center gap-4" data-id="element-68">
          <button className="text-[var(--muted)] hover:text-white transition-colors relative" data-id="element-69">
            <Bell className="w-5 h-5" data-id="element-70" />
            <span className="absolute top-0 right-0 w-2 h-2 bg-[var(--danger)] rounded-full border border-[var(--bg)]" data-id="element-71"></span>
          </button>

          {/* Avatar */}
          <button className="w-8 h-8 rounded-full bg-gradient-to-tr from-blue-500 to-purple-500 border border-white/10 overflow-hidden" aria-label="User profile" data-id="element-72"></button>
        </div>
      </div>
    </header>;
}